export default __webpack_public_path__ + "static/media/illustration_benefit4.0cdbffd3.png";